module.exports = __webpack_public_path__ + "static/media/food.152bd600.svg";